import { render, staticRenderFns } from "./CitySamples.vue?vue&type=template&id=048f12ba&"
import script from "./CitySamples.vue?vue&type=script&lang=js&"
export * from "./CitySamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports